<template>
	<label :class="['switch', { 'switch--small': small }]">
		<input type="checkbox" class="switch__input" :checked="modelValue" :disabled="disabled" @change="$emit('update:modelValue', $event.target.checked)" />
		<div class="switch__toggle">
			<div class="switch__handle"></div>
		</div>
	</label>
</template>
<script>
export default {
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue'],
}
</script>
<style scoped>
.switch {
	display: inline-block;
	vertical-align: top;
	box-sizing: border-box;
	background-clip: padding-box;
	position: relative;
	min-width: 51px;
	font-size: 17px;
	padding: 0 20px;
	border: none;
	overflow: visible;
	width: 51px;
	height: 32px;
	z-index: 0;
	text-align: left;
}
.switch--small {
	min-width: 40px;
	width: 40px;
	height: 24px;
	padding: 0 15px;
	font-size: 14px;
}
.switch__input {
	position: absolute;
	right: 0;
	top: 0;
	left: 0;
	bottom: 0;
	padding: 0;
	border: 0;
	background-color: transparent;
	z-index: 1;
	vertical-align: top;
	outline: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	opacity: 0;
}
.switch__toggle {
	background-color: #d6d6d6;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: 30px;
	transition-property: all;
	transition-duration: 0.35s;
	transition-timing-function: ease-out;
}
.switch--small .switch__toggle {
	border-radius: 24px;
}
.switch__handle {
	box-sizing: border-box;
	background-clip: padding-box;
	position: absolute;
	border-radius: 28px;
	height: 28px;
	width: 28px;
	background-color: #fff;
	left: 1px;
	top: 2px;
	transition-property: all;
	transition-duration: 0.35s;
	transition-timing-function: cubic-bezier(0.59, 0.01, 0.5, 0.99);
	box-shadow:
		0 0 1px 0 rgba(0, 0, 0, 0.25),
		0 3px 2px rgba(0, 0, 0, 0.25);
}
.switch--small .switch__handle {
	height: 20px;
	width: 20px;
	left: 2px;
	top: 2px;
	border-radius: 20px;
}
.switch__input:checked + .switch__toggle {
	box-shadow: inset 0 0 0 2px var(--color-success);
	background-color: var(--color-success);
}
.switch__input:checked + .switch__toggle > .switch__handle {
	left: 21px;
	box-shadow: 0 3px 2px rgba(0, 0, 0, 0.25);
}
.switch--small .switch__input:checked + .switch__toggle > .switch__handle {
	left: 18px;
}
.switch__input:disabled + .switch__toggle {
	opacity: 0.3;
	cursor: default;
	pointer-events: none;
}
</style>
